export default __webpack_public_path__ + "static/media/icons-project-document.ea599c13.svg";